import { render } from "./PPS_Message.vue?vue&type=template&id=0ce32f71"
import script from "./PPS_Message.vue?vue&type=script&lang=js"
export * from "./PPS_Message.vue?vue&type=script&lang=js"

import "./PPS_Message.vue?vue&type=style&index=0&id=0ce32f71&lang=scss"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__